export default __webpack_public_path__ + "static/media/s1_1.75d360e3.png";